<script lang="ts">
  import type { SnapshotOrderItem } from "../../../helpers/types";
  import TextNew from "../../TextNew.svelte";

  export let items: SnapshotOrderItem[] = [];
  export let collapseAt: number | undefined = undefined;

  let expanded = false;

  function toggleExpand() {
    expanded = !expanded;
  }

  $: actionTitle = expanded ? "show less" : "show all items";
  $: showAction = collapseAt && items.length > collapseAt;
  $: displayItems = collapseAt && !expanded ? items.slice(0, collapseAt) : items;
</script>

<div class="table">
  <div class="row header-row">
    <div class="column"><TextNew size="s" --rk-text-color="var(--rk-text-low)">code</TextNew></div>
    <div class="column"><TextNew size="s" --rk-text-color="var(--rk-text-low)">name</TextNew></div>
    <div class="column"><TextNew size="s" --rk-text-color="var(--rk-text-low)">unit</TextNew></div>
    <div class="column right-align">
      <TextNew size="s" --rk-text-color="var(--rk-text-low)">qty</TextNew>
    </div>
  </div>
  {#if items}
    <div class="table-content">
      {#each displayItems as item, index}
        <div class="row" class:no-border={!showAction && index === items.length - 1}>
          <div class="column">
            <TextNew size="s"
              >{item.buyer_product_reference?.length ? item.buyer_product_reference : "-"}</TextNew
            >
          </div>
          <div class="column"><TextNew size="s">{item.name}</TextNew></div>
          <div class="column"><TextNew size="s">{item.unit}</TextNew></div>
          <div class="column right-align"><TextNew size="s">{item.quantity}</TextNew></div>
        </div>
      {/each}
      {#if showAction}
        <div class="row no-border full-width">
          <button class="action full-width" on:click={toggleExpand}>
            {actionTitle}
          </button>
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  .table {
    display: grid;
    overflow: hidden;
  }

  .row {
    display: grid;
    grid-template-columns: 20% 55% 15% 10%;
    padding: 16px 8px;
    border-bottom: solid 1px var(--rk-divider-0);
  }

  .column {
    margin-right: 24px;
  }

  .no-border {
    border-bottom: none;
  }

  .table-content {
    max-height: 100%;
    overflow-y: scroll;
  }

  .right-align {
    text-align: right;
    margin-right: 0;
  }

  .full-width {
    display: flex;
    width: 100%;
  }

  .action {
    display: flex;
    justify-content: flex-start;
    color: var(--rk-text-low);
    font-family: "DiatypeRekki";
    font-size: var(--rk-font-size-s);
    line-height: var(--rk-line-height-s);
    letter-spacing: -0.3px;
  }

  .action:hover {
    cursor: pointer;
    color: var(--rk-text-dark);
  }
</style>
